import React, { Component } from "react";
import classnames from "classnames";
import styles from "./Job.scss";
import { connect } from "react-redux";
import {
	updateVisitor,
	setUserInfo
} from "../../../actions/DataCol/userdataAction";

class Job extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	updateUserInfo = () => {
		console.log(this.props.job);
		var job = {
			title: this.props.job.title,
			company: this.props.job.company,
			sectors: this.props.job.sectors
		};

		var user = this.props.user;
		if (user) {
			user["jobInterests"]["jobs"].push(job);
			console.log(user);
			updateVisitor(user);
			this.props.setUserInfo(user);
		}
	};

	render() {
		const { job } = this.props;
		return (
			<div className={styles.Job} key={job._id}>
				<div className={styles.LeftColumn}>
					<img src={job.img} alt="" className={styles.CompanyLogo} />
					{job.type && <p>Type: {job.type}</p>}
					{job.skills.lenth > 0 && <p>Skills: {job.skills}</p>}
					{job.bilingual && <p>{job.bilingual}</p>}
					{job.education && <p>Education: {job.education}</p>}
					{<br/>}
					{/* IN THE FUTURE, MAKE THIS OPEN IN A SMALL INLINE WINDOW */}
					{/*
					 */}
				</div>

				<div className={styles.RightColumn}>
					<h5>
						{job.title.length > 50
							? job.title.slice(0, 50) + "..."
							: job.title}
					</h5>
					<p>{job.company}</p>
					<a target="_blank" href={job.url}>
						See Job Posting
					</a>
					{job.description && (
						<p>
							{job.description.slice(0, 350) +
								(job.description.length > 350 ? "..." : "")}
						</p>
					)}
				</div>

				{this.props.showSimilarButtons && (
					<div className={styles.BottomBar}>
						<button
							className={classnames(
								styles.NotInterested,
								"btn z-depth-0"
							)}
							onClick={() => this.props.NotInterested(job._id)}
						>
							Not Interested
						</button>
						<button
							className={classnames(
								styles.ShowSimilar,
								"btn z-depth-0"
							)}
							onClick={() => {
								this.updateUserInfo();
								this.props.ShowSimilar(job._id);
							}}
						>
							Interested
						</button>
					</div>
				)}
				{!this.props.showSimilarButtons && (
					<div className={styles.BottomBar}>
						<a
							target="_blank"
							href={this.props.job.url}
							className={classnames(
								styles.ApplyButton,
								"btn z-depth-0"
							)}
							onClick={this.updateUserInfo}
						>
							Apply!
						</a>
					</div>
				)}
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		user: state.user.user
	};
}

const actions = {
	setUserInfo
};

export default connect(
	mapStateToProps,
	actions
)(Job);



// WEBPACK FOOTER //
// ./src/components/pages/Careers/Job.js